import Card from '@mui/material/Card';
import KartLogo from "../../constants/assests/image/karts_logo.png";
import Backgroundimg from "../../constants/assests/image/promotionBackground.png";
import { useNavigate } from "react-router-dom";
import { useSettings } from '../../../hooks/useSettings';

interface Props {
  pointAmount: any;
  userName: any;
  tier: any;
}
 

function HomeCard({ pointAmount, userName, tier }: Props) {
  const { settings, getSetting, loading } = useSettings();
   const primaryColor = getSetting('primary_color', process.env.REACT_APP_PRIMARY_COLOR || '#1E3A8A');
  const hoverColor = getSetting('widget_hover_color', process.env.REACT_APP_PRIMARY_COLOR_HOVER || '#2563EB');
  const storeName = getSetting('app_name', process.env.REACT_APP_STORE_NAME || 'Store');
// const primaryColor = process.env.APP_COLOR;
  const navigate = useNavigate();
  return (
    <div className="w-screen relative top-1">
      <Card
        className="p-4 shadow-lg m-4"
        sx={{
          borderRadius: "10px",
          backgroundColor: primaryColor,
          //backgroundImage: `url("https://firebasestorage.googleapis.com/v0/b/avada-joy.appspot.com/o/banner%2Fbranding%2F4GT36P7C0Gq0U7mtiZ9g%2Fbronze%20background.png?alt=media&token=3d990ea4-9254-48f0-8c3f-d59e48f3149a")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* <img src={KartLogo} alt="Karts Logo" /> */}
        <div className="flex flex-col space-y-6">
          {/* First Row */}
          <div className="flex text-white font-bold">
            <div className="flex flex-col flex-2 text-3xl font-medium">
              <p>Hi {userName} !</p>
            </div>
            <div className="flex flex-1 flex-col justify-center items-end">
              {/* Additional content can go here */}
              <button
                onClick={() => { navigate("/account"); }}
                className="text-white hover:text-blue-300 transition-colors"
                aria-label="Profile"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 22 24"
                >
                  <path
                    d="M12.12 12.78C12.05 12.77 11.96 12.77 11.88 12.78C10.12 12.72 8.71997 11.28 8.71997 9.50998C8.71997 7.69998 10.18 6.22998 12 6.22998C13.81 6.22998 15.28 7.69998 15.28 9.50998C15.27 11.28 13.88 12.72 12.12 12.78Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18.74 19.3801C16.96 21.0101 14.6 22.0001 12 22.0001C9.40001 22.0001 7.04001 21.0101 5.26001 19.3801C5.36001 18.4401 5.96001 17.5201 7.03001 16.8001C9.77001 14.9801 14.25 14.9801 16.97 16.8001C18.04 17.5201 18.64 18.4401 18.74 19.3801Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          {/* Second Row */}
          <div className="text-white">
            <div className="flex">
              {/* Column 1 */}
              <div className="w-1/2">
                <h2 className="text-base font-normal">Your Points</h2>
                <p className="text-3xl font-normal">{pointAmount}</p>
              </div>
              {/* Column 2 */}
              <div className="w-1/2">
                <h2 className="text-base font-normal">Your Tier</h2>
                <p className="text-2xl font-normal">{tier}</p>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default HomeCard;
